module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Session"},"de":{"title":"Spielsitzung"}}')
  delete Component.options._Ctor
}
